
import {throwError as observableThrowError, Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';

import * as _ from 'lodash';

import {HttpClientService} from './httpClient.service';
import {LanguageService} from "./language.service";

@Injectable()
export class FileTypeService {

  private _baseURL = "/api/fileTypes";

  constructor(private _http:HttpClientService, private _languageService:LanguageService) {
  }

  formatFileTypes(fileTypes:any[]) {
    //  Keep only type with name field having at least one non trivial supported translation
    let validFileTypes = _.filter(fileTypes, fileType => {
      return fileType.name && this._languageService.getFirstExistingTranslation(fileType.name);
    });

    return _.orderBy(_.map(validFileTypes, type => {
      return {
        value: type.name[this._languageService.getCurrentLanguage()] || this._languageService.getFirstExistingTranslation(type.name)
      };
    }), 'value');
  }

  getAll() {
    let url = this._baseURL;

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map((res: any) => {
        return this.formatFileTypes(res);
      }),
      catchError(this._handleError),);
  }

  getMe() {
    let url = this._baseURL + '/me';

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map((res: any) => {
        return this.formatFileTypes(res);
      }),
      catchError(this._handleError),);
  }

  getAdmin() {
    let url = this._baseURL + "/admin";

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError),);
  }

  get() {
    let url = this._baseURL + "/me";

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError),);
  }

  removeGlobal(e) {
    let url = this._baseURL + '/' + e._id;

    //noinspection TypeScriptValidateTypes
    return this._http.delete(url).pipe(
      map(res => res),
      catchError(this._handleError),);
  }

  addGlobal(name) {
    let url = this._baseURL;
    let headers = new HttpHeaders({'Content-Type': 'application/json'});

    //noinspection TypeScriptValidateTypes
    return this._http.post(url, JSON.stringify(name), headers).pipe(
      map((res: any) => res.err),
      catchError(this._handleError),);
  }

  private _handleError(error) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return observableThrowError(error['message'] || error['_body'] || 'Server error');
  }
}
